import { render, staticRenderFns } from "./PluginFloatingIconMenu.vue?vue&type=template&id=0ba10028"
import script from "./PluginFloatingIconMenu.vue?vue&type=script&lang=js"
export * from "./PluginFloatingIconMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba10028')) {
      api.createRecord('0ba10028', component.options)
    } else {
      api.reload('0ba10028', component.options)
    }
    module.hot.accept("./PluginFloatingIconMenu.vue?vue&type=template&id=0ba10028", function () {
      api.rerender('0ba10028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginFloatingIconMenu.vue"
export default component.exports